export const FirebaseConfig = {
	"projectId": "empeconnect",
	"appId": "1:734948201973:web:a02f9b48d20a586852fcbc",
	"databaseURL": "https://empeconnect-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "empeconnect.appspot.com",
	"locationId": "europe-west",
	"apiKey": "AIzaSyC9CMrD40ZYDs-kcu2KxZaRiBmKwo2Z3qo",
	"authDomain": "empeconnect.firebaseapp.com",
	"messagingSenderId": "734948201973",
	"measurementId": "G-JSFJ4DH42S"
};